export const heroStats = [
  { id: "s1", value: "6", label: "主题分区" },
  { id: "s2", value: "4", label: "年代脉络" },
  { id: "s3", value: "30+", label: "片单条目" },
  { id: "s4", value: "6", label: "关键词解读" },
];

export const featuredFilms = [
  {
    id: "f1",
    title: "英雄本色",
    year: "1986",
    tags: ["港片", "动作片"],
    director: "吴宇森",
    lead: "周润发 / 狄龙 / 张国荣",
    summary: "以兄弟情义与枪战美学为骨架的黑帮动作片，慢镜头与双枪走位成为此后被反复回望的银幕符号。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20retro%20Hong%20Kong%20crime%20film%20poster%20art%2C%20two%20silhouetted%20figures%20in%20long%20coats%20under%20warm%20red%20neon%20light%2C%20rain%20slicked%20street%2C%20painterly%20illustration%2C%20deep%20crimson%20and%20gold%20palette%2C%20no%20text%2C%20dramatic%20cinematic%20lighting%2C%20grainy%20film%20texture&width=600&height=840&seq=dashixiong-featured-01&orientation=portrait",
  },
  {
    id: "f2",
    title: "黄飞鸿",
    year: "1991",
    tags: ["武侠片", "动作片"],
    director: "徐克",
    lead: "李连杰",
    summary: "将南派武术与家国情怀放在同一舞台的武侠系列，凌厉的武打编排与开阔的时代气象，是很多人心中武侠片的入门坐标。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20vintage%20Chinese%20martial%20arts%20movie%20poster%2C%20a%20martial%20artist%20in%20traditional%20robe%20mid%20pose%20in%20a%20misty%20courtyard%2C%20ink%20wash%20and%20painterly%20illustration%2C%20warm%20amber%20and%20brown%20tones%2C%20no%20text%2C%20epic%20cinematic%20lighting%2C%20aged%20paper%20texture&width=600&height=840&seq=dashixiong-featured-02&orientation=portrait",
  },
  {
    id: "f3",
    title: "警察故事",
    year: "1985",
    tags: ["动作片", "经典电影"],
    director: "成龙",
    lead: "成龙 / 林青霞 / 张曼玉",
    summary: "以实拍高危动作见长的警匪动作片，大量亲身上阵的追逐与跳跃，把动作片的观赏重心放在真实的体能与调度上。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20eighties%20action%20movie%20poster%20art%2C%20a%20stuntman%20leaping%20across%20a%20neon%20lit%20city%20alley%20at%20night%2C%20motion%20blur%2C%20painterly%20illustration%2C%20teal%20shadow%20with%20warm%20orange%20highlights%2C%20no%20text%2C%20dynamic%20cinematic%20composition&width=600&height=840&seq=dashixiong-featured-03&orientation=portrait",
  },
  {
    id: "f4",
    title: "倩女幽魂",
    year: "1987",
    tags: ["武侠片", "老电影"],
    director: "程小东",
    lead: "张国荣 / 王祖贤",
    summary: "把武侠、奇幻与人鬼情缘揉在一起的作品，雾气、灯笼与飘带构成独特的东方美学，是怀旧剧场里常被重看的经典。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20eerie%20ancient%20Chinese%20fantasy%20movie%20poster%2C%20a%20lone%20figure%20with%20flowing%20white%20robe%20in%20misty%20bamboo%20forest%20under%20dim%20lantern%20light%2C%20painterly%20illustration%2C%20muted%20jade%20and%20amber%20tones%2C%20no%20text%2C%20dreamy%20cinematic%20atmosphere&width=600&height=840&seq=dashixiong-featured-04&orientation=portrait",
  },
];

export const hkClassics = [
  {
    id: "h1",
    title: "纵横四海",
    year: "1991",
    tags: ["港片", "动作片"],
    line: "盗宝题材与侠义气质结合，人物之间的默契与洒脱，是港片里少见的轻盈浪漫。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20retro%20Hong%20Kong%20heist%20movie%20poster%20art%2C%20elegant%20figures%20in%20suits%20on%20a%20European%20bridge%20at%20golden%20hour%2C%20painterly%20illustration%2C%20warm%20amber%20and%20cream%20palette%2C%20no%20text%2C%20light%20cinematic%20mood&width=600&height=840&seq=dashixiong-hk-01&orientation=portrait",
  },
  {
    id: "h2",
    title: "喋血双雄",
    year: "1989",
    tags: ["港片", "动作片"],
    line: "杀手与警探在枪火中互相辨认，把对立关系写成带着宿命感的相互敬意。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20noir%20Hong%20Kong%20action%20movie%20poster%2C%20two%20figures%20back%20to%20back%20holding%20pistols%20in%20a%20candle%20lit%20church%2C%20painterly%20illustration%2C%20deep%20red%20and%20shadow%20black%20palette%2C%20no%20text%2C%20dramatic%20cinematic%20lighting&width=600&height=840&seq=dashixiong-hk-02&orientation=portrait",
  },
  {
    id: "h3",
    title: "赌神",
    year: "1989",
    tags: ["港片", "经典电影"],
    line: "把赌桌拍成心理攻防的舞台，节奏、音乐与造型共同塑造了一个时代的流行记忆。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20retro%20casino%20movie%20poster%20art%2C%20a%20confident%20figure%20at%20a%20green%20felt%20table%20surrounded%20by%20fanned%20playing%20cards%20and%20warm%20lamplight%2C%20painterly%20illustration%2C%20gold%20and%20deep%20brown%20palette%2C%20no%20text%2C%20glamorous%20cinematic%20tone&width=600&height=840&seq=dashixiong-hk-03&orientation=portrait",
  },
  {
    id: "h4",
    title: "无间道",
    year: "2002",
    tags: ["港片", "经典电影"],
    line: "以身份错位与心理博弈为核心的警匪片，冷静的剪辑与克制的表演让港片在千禧年后继续保持锋利。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20moody%20crime%20thriller%20movie%20poster%2C%20two%20silhouettes%20standing%20on%20a%20rooftop%20overlooking%20a%20night%20skyline%2C%20painterly%20illustration%2C%20cool%20charcoal%20and%20amber%20accents%2C%20no%20text%2C%20tense%20cinematic%20atmosphere&width=600&height=840&seq=dashixiong-hk-04&orientation=portrait",
  },
  {
    id: "h5",
    title: "甜蜜蜜",
    year: "1996",
    tags: ["港片", "老电影"],
    line: "把大时代里的小人物情感写得细腻动人，市井气息与流动的都市记忆交织在一起。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20nostalgic%20romance%20movie%20poster%20art%2C%20two%20figures%20on%20bicycles%20along%20a%20busy%20old%20street%20with%20hanging%20signs%2C%20painterly%20illustration%2C%20soft%20sepia%20and%20rose%20tones%2C%20no%20text%2C%20gentle%20cinematic%20warmth&width=600&height=840&seq=dashixiong-hk-05&orientation=portrait",
  },
  {
    id: "h6",
    title: "精武门",
    year: "1972",
    tags: ["港片", "动作片", "老电影"],
    line: "功夫片的代表性作品之一，以直接有力的动作与强烈的民族情绪，影响了后来大量动作电影的拍法。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20seventies%20kung%20fu%20movie%20poster%2C%20a%20muscular%20fighter%20in%20classic%20stance%20in%20a%20traditional%20training%20hall%2C%20painterly%20illustration%2C%20earthy%20ochre%20and%20deep%20brown%20palette%2C%20no%20text%2C%20bold%20cinematic%20lighting&width=600&height=840&seq=dashixiong-hk-06&orientation=portrait",
  },
];

export const actionFilms = [
  {
    id: "a1",
    title: "A计划",
    year: "1983",
    tags: ["动作片", "怀旧剧场"],
    note: "以杂技式身体喜剧与高风险实拍结合，把动作与笑料缝在同一条节奏线上。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20vintage%20action%20comedy%20poster%20art%2C%20acrobatic%20figure%20dangling%20from%20a%20clock%20tower%20at%20dusk%2C%20painterly%20illustration%2C%20warm%20orange%20and%20brown%20palette%2C%20no%20text%2C%20playful%20cinematic%20energy&width=400&height=560&seq=dashixiong-action-01&orientation=portrait",
  },
  {
    id: "a2",
    title: "龙争虎斗",
    year: "1973",
    tags: ["动作片", "老电影"],
    note: "功夫片走向国际的重要节点，简洁直接的格斗与镜面场景的调度至今被讨论。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20seventies%20martial%20arts%20poster%20art%2C%20a%20lone%20fighter%20facing%20mirrored%20walls%20in%20a%20dim%20hall%2C%20painterly%20illustration%2C%20golden%20amber%20and%20shadow%20palette%2C%20no%20text%2C%20tense%20cinematic%20mood&width=400&height=560&seq=dashixiong-action-02&orientation=portrait",
  },
  {
    id: "a3",
    title: "醉拳",
    year: "1978",
    tags: ["动作片", "怀旧剧场"],
    note: "把招式拆解成带有喜剧节拍的舞蹈，练功段落本身就是一场完整的表演。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20vintage%20drunk%20fist%20kung%20fu%20poster%2C%20a%20figure%20in%20flowing%20robe%20balancing%20in%20a%20drunken%20stance%20inside%20a%20courtyard%2C%20painterly%20illustration%2C%20warm%20amber%20and%20olive%20palette%2C%20no%20text%2C%20lively%20cinematic%20tone&width=400&height=560&seq=dashixiong-action-03&orientation=portrait",
  },
  {
    id: "a4",
    title: "红番区",
    year: "1995",
    tags: ["动作片", "港片"],
    note: "跨国取景与大规模实拍特技的组合，展示了港式动作片在工业化调度上的野心。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20nineties%20action%20movie%20poster%20art%2C%20a%20figure%20leaping%20between%20rooftops%20above%20a%20dense%20night%20city%2C%20painterly%20illustration%2C%20cool%20charcoal%20with%20warm%20red%20neon%20accents%2C%20no%20text%2C%20high%20energy%20cinematic%20composition&width=400&height=560&seq=dashixiong-action-04&orientation=portrait",
  },
];

export const wuxiaFilms = [
  {
    id: "w1",
    title: "新龙门客栈",
    year: "1992",
    tags: ["武侠片", "港片"],
    point: "客栈空间",
    desc: "把故事压缩在一间客栈里，人物关系随进出场不断变化，室内调度与风沙外景形成强烈对照。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20desert%20inn%20martial%20arts%20scene%2C%20a%20wooden%20tavern%20in%20a%20vast%20sandy%20landscape%20with%20distant%20riders%2C%20painterly%20illustration%2C%20golden%20sand%20and%20deep%20brown%20palette%2C%20no%20text%2C%20epic%20windy%20cinematic%20atmosphere&width=800&height=600&seq=dashixiong-wuxia-01&orientation=landscape",
  },
  {
    id: "w2",
    title: "东邪西毒",
    year: "1994",
    tags: ["武侠片", "经典电影"],
    point: "情绪与独白",
    desc: "更接近散文式的武侠，用大漠、独白与留白讲述记忆与错过，动作被处理成情绪的一部分。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20poetic%20desert%20martial%20arts%20poster%2C%20a%20solitary%20figure%20before%20an%20empty%20vast%20dune%20under%20a%20hazy%20sun%2C%20painterly%20illustration%2C%20muted%20amber%20and%20dusty%20rose%20palette%2C%20no%20text%2C%20melancholic%20cinematic%20mood&width=800&height=600&seq=dashixiong-wuxia-02&orientation=landscape",
  },
  {
    id: "w3",
    title: "笑傲江湖",
    year: "1990",
    tags: ["武侠片", "老电影"],
    point: "江湖与自由",
    desc: "以江湖恩怨为背景谈个人选择，既有刀光剑影，也保留了原著的洒脱与不羁。",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20classic%20wuxia%20scene%2C%20swordsman%20standing%20on%20a%20cliff%20above%20a%20river%20gorge%20with%20mist%2C%20painterly%20ink%20illustration%2C%20jade%20green%20and%20warm%20stone%20palette%2C%20no%20text%2C%20free%20spirited%20cinematic%20tone&width=800&height=600&seq=dashixiong-wuxia-03&orientation=landscape",
  },
];

export const eras = [
  {
    id: "e1",
    range: "1960s – 1970s",
    title: "奠基：武侠片与功夫片成形",
    desc: "这一阶段，古装武侠与功夫题材在银幕上确立了自己的语言：程式化的招式、清晰的善恶对抗与强调身体表现的镜头，成为后来动作片的共同底色。",
    marks: ["邵氏武侠的棚拍美学", "李小龙式格斗的直给感", "练功与门派叙事的定型"],
  },
  {
    id: "e2",
    range: "1980s",
    title: "黄金期：港片的类型爆发",
    desc: "警匪、枪战、黑帮、喜剧与动作片在同一时期彼此借鉴，制作节奏加快，明星与类型高度绑定，形成了被反复回望的港片黄金年代。",
    marks: ["英雄片与双枪美学", "实拍特技的极限尝试", "喜剧与动作的混搭"],
  },
  {
    id: "e3",
    range: "1990s",
    title: "新浪潮：武侠与类型的再编排",
    desc: "武侠片迎来视觉与叙事的更新，吊威亚与快速剪辑带来更飘逸的武打观感；同时赌片、无厘头喜剧等新类型不断出现，构成多元的九十年代。",
    marks: ["武侠新浪潮的飘逸武打", "赌片与心理攻防", "无厘头喜剧的节奏"],
  },
  {
    id: "e4",
    range: "2000s – 至今",
    title: "重看：修复、回顾与怀旧剧场",
    desc: "随着修复放映与线上重看变多，经典电影以新的画质重新被讨论。观众不再只看情节，也会关注调度、配乐与那个时代的城市气息。",
    marks: ["经典修复与重映", "影迷向的调度解读", "怀旧剧场的慢看方式"],
  },
];

export const browseItems = [
  { id: "b1", title: "英雄本色", year: "1986", tags: ["港片", "动作片", "经典电影"], meta: "兄弟情义 · 枪战美学" },
  { id: "b2", title: "警察故事", year: "1985", tags: ["动作片", "港片"], meta: "实拍特技 · 警匪追逐" },
  { id: "b3", title: "黄飞鸿", year: "1991", tags: ["武侠片", "动作片"], meta: "南派武术 · 家国气象" },
  { id: "b4", title: "倩女幽魂", year: "1987", tags: ["武侠片", "老电影"], meta: "东方奇幻 · 人鬼情缘" },
  { id: "b5", title: "精武门", year: "1972", tags: ["老电影", "动作片"], meta: "功夫经典 · 民族情绪" },
  { id: "b6", title: "醉拳", year: "1978", tags: ["动作片", "怀旧剧场"], meta: "喜剧节拍 · 练功表演" },
  { id: "b7", title: "纵横四海", year: "1991", tags: ["港片", "动作片"], meta: "盗宝侠义 · 轻盈浪漫" },
  { id: "b8", title: "赌神", year: "1989", tags: ["港片", "经典电影"], meta: "赌桌攻防 · 流行记忆" },
  { id: "b9", title: "无间道", year: "2002", tags: ["港片", "经典电影"], meta: "身份错位 · 心理博弈" },
  { id: "b10", title: "新龙门客栈", year: "1992", tags: ["武侠片", "港片"], meta: "客栈空间 · 室内调度" },
  { id: "b11", title: "东邪西毒", year: "1994", tags: ["武侠片", "经典电影"], meta: "大漠独白 · 散文武侠" },
  { id: "b12", title: "甜蜜蜜", year: "1996", tags: ["港片", "老电影"], meta: "都市记忆 · 细腻情感" },
  { id: "b13", title: "A计划", year: "1983", tags: ["动作片", "怀旧剧场"], meta: "身体喜剧 · 实拍冒险" },
  { id: "b14", title: "龙争虎斗", year: "1973", tags: ["动作片", "老电影"], meta: "镜面格斗 · 走向国际" },
  { id: "b15", title: "笑傲江湖", year: "1990", tags: ["武侠片", "老电影"], meta: "江湖自由 · 洒脱不羁" },
  { id: "b16", title: "红番区", year: "1995", tags: ["动作片", "港片"], meta: "跨国取景 · 工业调度" },
];

export const browseTags = ["全部", "港片", "动作片", "武侠片", "经典电影", "老电影", "怀旧剧场"];

export const guideItems = [
  {
    id: "g1",
    q: "第一次看港片，从哪一部开始比较好？",
    a: "如果更在意节奏与情绪，可以从八十年代的英雄片与警匪片入手；如果偏爱武打，可以先看九十年代的武侠片；若想感受更早的银幕气质，则从六七十年代的功夫片看起。三个入口对应三种不同的观影节奏，不必按时间顺序。",
  },
  {
    id: "g2",
    q: "看老电影时画面模糊怎么办？",
    a: "早期影片的画质受制于当年的胶片与保存条件，颗粒感和音轨噪点属于时代特征。建议在安静的环境下观看，把注意力放到调度、灯光与表演上，往往比只看情节更能体会老片的味道。",
  },
  {
    id: "g3",
    q: "武侠片和动作片应该怎么区分？",
    a: "两者常常重叠。一般来说，武侠片更强调江湖背景、门派与个人道义，武打带有写意与程式感；动作片则更偏向现代题材与实拍调度，如警匪追逐、特技与搏击。判断时看故事的世界观会更清楚。",
  },
  {
    id: "g4",
    q: "怀旧剧场适合怎样观看？",
    a: "怀旧剧场更适合慢看：不必一次看完，可以按年代或类型分主题观看，看完一部再找同期的另一部做对照。这样更容易发现不同年代在配乐、剪辑与造型上的差别。",
  },
];

export const keywordCards = [
  {
    id: "k1",
    key: "港片",
    desc: "指以香港为主要制作背景的电影，题材覆盖警匪、动作、喜剧、爱情等，以节奏明快、类型混合与强烈的都市感著称。",
    icon: "ri-film-line",
  },
  {
    id: "k2",
    key: "经典电影",
    desc: "在多年之后仍被反复重看与讨论的作品，魅力往往来自调度、表演与时代气息，而不只是当年的话题度。",
    icon: "ri-award-line",
  },
  {
    id: "k3",
    key: "动作片",
    desc: "以身体动作、搏击与特技为观赏核心的类型，优秀作品会把动作编排与人物情绪放进同一条节奏线里。",
    icon: "ri-boxing-line",
  },
  {
    id: "k4",
    key: "武侠片",
    desc: "以江湖、门派与个人道义为背景的类型，武打带有写意与程式感，常借刀剑讲述选择与自由。",
    icon: "ri-sword-line",
  },
  {
    id: "k5",
    key: "老电影",
    desc: "指年代较早的影片，画质与音轨带着胶片时代的痕迹，理解其拍摄条件，往往能看出更多讲究。",
    icon: "ri-history-line",
  },
  {
    id: "k6",
    key: "怀旧剧场",
    desc: "以重看与回顾为核心的观看方式，按年代或类型分主题慢慢看，更容易体会不同时期的气质差异。",
    icon: "ri-movie-2-line",
  },
];

export const faqs = [
  {
    id: "q1",
    q: "大师兄影视这个页面主要提供什么？",
    a: "这是一个以港片、经典电影、动作片、武侠片、老电影与怀旧剧场为主题的内容页面，把不同类型的片单、年代脉络与观影线索整理成可浏览、可筛选、可展开阅读的分区。",
  },
  {
    id: "q2",
    q: "页面上的筛选和搜索会联网吗？",
    a: "不会。分区里的标签切换与关键词搜索只在当前页面已有的片单条目中筛选，不连接任何接口，也不会上传或保存你的输入。",
  },
  {
    id: "q3",
    q: "片单里的介绍准确吗？",
    a: "页面内容是对类型与年代的一般性整理与介绍，用于提供观影线索，不涉及具体商业数据与未经证实的细节。不同版本与修复版之间可能存在差异，观看时以实际发行信息为准。",
  },
  {
    id: "q4",
    q: "在手机上浏览方便吗？",
    a: "页面针对桌面与移动端都做了适配，卡片会在窄屏下自动改为单列或两列，标签与搜索栏也可以横向滑动，正文在手机上同样可以顺畅阅读。",
  },
];